import { render } from "./widgetForm.vue?vue&type=template&id=25f4194d&scoped=true"
import script from "./widgetForm.vue?vue&type=script&lang=js"
export * from "./widgetForm.vue?vue&type=script&lang=js"

import "./widgetForm.vue?vue&type=style&index=0&id=25f4194d&lang=less&scoped=true"

import exportComponent from "/data/app_data/product_data/deploy-center-mars/s3-deploy/damocstp/panel-cspt/v1.4.2-20260320-150211/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f4194d"]])

export default __exports__